import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
// Ust
import { useInvAF } from "../../../../St/Reviews/UseStyle";
// csG
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors, Container, makeStyles, Typography } from "@material-ui/core";
import { useBody } from "../../invCompany/style";
import { txtA, txtE } from "../../../../Label/Lbl";
import InvTotal from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { Rept } from "../../../../Context/InshData";
import { getcolor } from "../../invCompany/A4/UnderHeader";
import TotalsCom from "./TotalsCom";

const BodyCom = (props) => {
  const cls = useRptAF();
  const {  data, isLast, inv, sta, locInv ,found } = props;

  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    { title: "Item Id \n الكود", field: "barcode" },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellS },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Qoantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },
    { title: "Tax \n  الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  const data2 = data.map((row, i) => {
    return {
      ...row,
      id: i + 1,
      totBill: row.totBill.toFixed(2),
      new_exchange_price: row.exchange_price.toFixed(locInv?.NRound ?? 4),
      tot_net_curr: row.tot_net_curr.toFixed(2),
      discount: row.discount.toFixed(2),
    };
  });
  const invColors = sta?.StngIA?.colors;

  const secondColor = getcolor(invColors);


  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: "ltr", border: "dotted 1px #393939",
        }}>
        <Grid
          item
          xs={12}
          style={{
          }}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
              rowStyle: (rowData, i) => ({
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                backgroundColor: i % 2 === 0 ? "#fff" : secondColor,
              }),
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={columns.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))}
            data={data2}
          />

          <Grid item xs={12} style={{ direction: "rtl" }}>
            <>
              {isLast && <TotalsCom found={found} inv={inv} sta={sta} />}
            </>

          </Grid>

        </Grid>
      </Grid>

    </Grid>
  );
};

export default BodyCom;
